import React, { createContext, useContext } from "react";

import { useStorageManager } from "./useStorageManager";

const StorageContext = createContext(null);
const fallbackStorage = {
  mode: "cloud",
  adapter: null,
  cloudAvailable: false,
  inspectSources: async () => ({ localProjects: [], cloudProjects: [], localCount: 0, cloudCount: 0 }),
  preferredMode: "cloud",
  setPreferredMode: () => {},
  loadProjects: async () => {
    throw new Error("StorageProvider unavailable: cloud storage not ready.");
  },
  loadProject: async () => {
    throw new Error("StorageProvider unavailable: cloud storage not ready.");
  },
  saveProject: async () => {
    throw new Error("StorageProvider unavailable: cloud storage not ready.");
  },
  deleteProject: async () => {
    throw new Error("StorageProvider unavailable: cloud storage not ready.");
  },
  createProject: async () => {
    throw new Error("StorageProvider unavailable: cloud storage not ready.");
  },
  lastError: null,
  clearError: () => {},
  forceLocal: false,
  isAuthReady: true,
};

export function StorageProvider({ children }) {
  const storage = useStorageManager();
  return <StorageContext.Provider value={storage}>{children}</StorageContext.Provider>;
}

export function useStorage() {
  const ctx = useContext(StorageContext);
  return ctx || fallbackStorage;
}
